export const getSiteResponseProgress = (data) => {
  const checks = [
    data?.designation_pa_id != null && data?.designation_oecms_id != null,
    data?.response_planning_id != null,
    data?.response_action_id != null,
    data?.actions_needed_underway !== 0,
    data?.actions_needed_count !== 0
  ]

  const completed = checks.filter(Boolean).length

  return data ? (completed / checks.length) * 100 : 0
}

export const getPressureProgress = (monitoring) => {
  const pressureData = monitoring?.pressureBiodiversity
  if (!pressureData) return 0

  const total = pressureData?.pressuresTotal || 0
  if (total === 0) return 0

  const triggersRatio = (pressureData?.pressuresWithTriggersAdded || 0) / total

  return Math.min(100, Math.round(triggersRatio * 100))
}

export const canEvaluationBeSubmitted = (monitoring) => {
  const atLeastOneSelected =
    monitoring?.state_evaluation === true ||
    monitoring?.pressure_evaluation === true ||
    monitoring?.response_evaluation === true

  const speciesBenchmark = monitoring?.biodiversity?.speciesBenchmarkCounts
  const ecoBenchmark = monitoring?.biodiversity?.ecoBenchmarkCounts
  const stateCompleted =
    monitoring?.biodiversity?.totalBenchmarkCounts?.completed ??
    ((speciesBenchmark?.completed || 0) + (ecoBenchmark?.completed || 0))
  const stateStarted =
    monitoring?.biodiversity?.totalBenchmarkCounts?.started ??
    ((speciesBenchmark?.started || 0) + (ecoBenchmark?.started || 0))

  const canSubmitState = !monitoring?.state_evaluation
    ? true
    : stateCompleted > 0 && stateStarted === 0

  const pressureTotal = monitoring?.pressureBiodiversity?.pressuresTotal || 0
  const canSubmitPressure = !monitoring?.pressure_evaluation
    ? true
    : pressureTotal > 0 &&
      monitoring?.pressureBiodiversity?.pressuresWithTriggersAdded === pressureTotal

  const responseProgress = getSiteResponseProgress(monitoring?.site_responses?.[0])
  const canSubmitResponse = !monitoring?.response_evaluation
    ? true
    : monitoring?.isSiteResponseValidated && responseProgress === 100

  return atLeastOneSelected && canSubmitState && canSubmitPressure && canSubmitResponse && (monitoring?.isAboutValid ?? true)
}

export const isSectionComplete = (section) => {
  if (typeof section === 'boolean') {
    return section
  }
  const values = Object.values(section || {})
  if (values.length === 0) return false

  return values.every((element) => element === true)
}

export const getUncompletedSection = (validation, monitoring) => {
  const result = []
  if (!isSectionComplete(validation?.about)) {
    result.push('About')
  }

  if (validation?.oneTabRequired === false) {
    result.push('oneTabRequired')
  }

  if (
    monitoring?.response_evaluation === true &&
    (!isSectionComplete(validation?.siteResponse ?? true) || !validation?.siteResponse)
  ) {
    result.push('Response')
  }

  if (
    monitoring?.state_evaluation === true &&
    !isSectionComplete(validation?.siteState?.result ?? true)
  ) {
    result.push('State')
  }

  if (
    monitoring?.pressure_evaluation === true &&
    !isSectionComplete(validation?.sitePressure?.result ?? true)
  ) {
    result.push('Pressure')
  }

  return [...new Set(result)]
}

export const toPercentSegments = (percent) => [
  { key: 'filled', value: percent, fill: '#F59E0B', labelId: 'monitoringValue', labelDefaultMessage: 'Value' },
  {
    key: 'remaining',
    value: 100 - percent,
    fill: '#e2e5e9',
    labelId: 'monitoringRemaining',
    labelDefaultMessage: 'Remaining'
  }
]

export const toSegments = (counts) => [
  {
    key: 'complete',
    value: counts?.completed || 0,
    fill: '#22C55E',
    labelId: 'monitoringLegendComplete',
    labelDefaultMessage: 'Complete'
  },
  {
    key: 'started',
    value: counts?.started || 0,
    fill: '#F59E0B',
    labelId: 'monitoringLegendStarted',
    labelDefaultMessage: 'Started, not complete'
  },
  {
    key: 'notStarted',
    value: counts?.notStarted || 0,
    fill: '#D9D9D9',
    labelId: 'monitoringLegendNotStarted',
    labelDefaultMessage: 'Not started'
  }
]

export const getChartState = (counts) => ({
  completed: counts?.completed || 0,
  started: counts?.started || 0,
  notStarted: counts?.notStarted || 0
})
